export enum NAMESPACE {
  login = 'login',
  signup = 'signup',
  common = 'common',
  passwordRecovery = 'password-recovery'
}
